import React, { useCallback } from 'react';
import { m } from 'framer-motion';
import { styled } from '@linaria/react';
import { COLORS, DirectionalIcon, typographyStyles } from '@livecommerce/design-system';

const { getBodyText } = typographyStyles;

const Content = styled.div`
  margin: 3px;
  padding: 10px 16px;
  border-radius: 16px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  user-select: none;
  border: ${(props) => props.active ? `2px solid ${COLORS.orange_500}` : 'none'};
  background-color: ${(props) => props.isClickable ? COLORS.dark_1000 : 'transparent'};

  cursor: ${(props) => props.isClickable ? 'pointer' : 'default'};
  &:hover {
    background-color: ${(props) => props.isClickable ? COLORS.dark_600 : 'transparent'};
  }
`;

const Label = styled.div`
  color: ${COLORS.light_700};
  ${getBodyText(12, 400)};
  line-height: 18px;
`;

const Chevron = styled(DirectionalIcon)`
  display: inline-block;
  top: 0.25em;
  position: relative;
  left: -0.5em;
  height: 1.2em;
`;

const HeaderItem = (props) => {
  const { children, label, onClick, active, ...rest } = props;

  const wrappedOnClick = useCallback(() => {
    if (typeof onClick === 'function') {
      onClick();
    }
  }, [onClick]);

  const isClickable = typeof onClick === 'function';

  return (
    <m.div layout="position" {...rest}>
      <Content onClick={wrappedOnClick} isClickable={isClickable} active={active}>
        {children}
        <Label>{label} {isClickable && <Chevron name="chevron" direction="right" />}</Label>
      </Content>
    </m.div>
  );
};

export default HeaderItem;
